import { uisRequest } from "./axios"

/**
 * @description 获取@用户列表
 * @param {{prefix:String, authorId:String, sourceId:String, pageNo:Number, size:Number}} params
 * @returns {Promise<{code:Number, data:Object}>} 用户列表
 */
export const getAtUserList = async (params) => {
    try {
        const data = await uisRequest.get("/comment/api/at/search", {
            params: params,
            withCredentials: true,
        })
        return data
    } catch (error) {
        throw new Error("获取@用户列表报错," + error.message)
    }
}
